import { useState } from "react";
import "./OnlineTrafficSchool.css";
import AudioSamplePlayer from "../../components/AudioSamplePlayer";
import { courses } from "../../data/online-traffic-school";
import slide1Img from "@/assets/images/slide-1.jpg";
import PackageCard from "../../components/PackageCard";

const OnlineTrafficSchool = () => {
  const [hoveredCardId, setHoveredCardId] = useState(null);
  return (
    <>
      <section className="hero-slider-section">
        <div
          className="hero-banner"
          style={{
            backgroundImage: `url(${slide1Img})`,
          }}
        >
          <div className="banner-text-container">
            <div className="banner-heading">
              <p className="banner-title">Online Traffic school</p>
              <h1 className="banner-subheading">
                Please choose from our convenient online classes below
              </h1>
            </div>
          </div>
        </div>
      </section>
      <main className="online-traffic-school-page">
        <div className="container my-5">
          <div className="row mb-4">
            <div className="col-12">
              <div className="d-flex justify-content-end gap-3 fw-bold text-white">
                <a
                  href="https://courses.metrotrafficschool.com/onlinecourses/index.php/login?awc_id=Mzg0"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white text-decoration-none"
                >
                  Returning students
                </a>
                <span>|</span>
                <a
                  href="/traffic-school-program"
                  className="text-white text-decoration-none"
                >
                  More info on courses
                </a>
              </div>
            </div>
          </div>

          {(() => {
            const firstRow = courses.slice(0, 3);
            const secondRow = courses.slice(3);
            return (
              <>
                <div className="row g-4">
                  {firstRow.map((c) => (
                    <div className="col-12 col-sm-6 col-lg-4" key={c.id}>
                      <PackageCard
                        pkg={{
                          ...c,
                          registerLink: c.registerUrl,
                          infoLink: c.infoUrl,
                        }}
                        hoveredCardId={hoveredCardId}
                        setHoveredCardId={setHoveredCardId}
                        registerText="Register"
                        moreInfoText="(More info)"
                      />
                    </div>
                  ))}
                </div>
                <div className="row g-4 justify-content-center mt-1">
                  {secondRow.map((c) => (
                    <div className="col-12 col-sm-6 col-lg-4" key={c.id}>
                      <PackageCard
                        pkg={{
                          ...c,
                          registerLink: c.id === 5 ? null : c.registerUrl,
                          infoLink: c.infoUrl,
                        }}
                        hoveredCardId={hoveredCardId}
                        setHoveredCardId={setHoveredCardId}
                        registerText="Register"
                        moreInfoText="(More info)"
                        isRegisterButton={c.id === 5}
                        registerButtonProps={
                          c.id === 5
                            ? {
                              type: "button",
                              "data-bs-toggle": "modal",
                              "data-bs-target": "#mature-info-modal",
                            }
                            : {}
                        }
                      />
                    </div>
                  ))}
                </div>
              </>
            );
          })()}

          <div
            className="modal fade"
            id="mature-info-modal"
            tabIndex="-1"
            aria-labelledby="matureInfoLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content bg-dark text-white">
                <div className="modal-header bg-dark border-0">
                  <h5 className="modal-title" id="matureInfoLabel">
                    Mature Driver Course
                  </h5>
                  <button
                    type="button"
                    className="btn-close btn-close-white"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body bg-dark">
                  <p className="mb-0">
                    This course is currently not being offered online. Only in
                    classroom version. For more information please call{" "}
                    <a href="tel:3055535000">305-553-5000</a>.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="row gx-4 gy-3 align-items-center justify-content-center my-3 mt-5">
            <div className="col-12 col-lg-8 col-xl-7">
              <AudioSamplePlayer />
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default OnlineTrafficSchool;
